module.exports = __webpack_public_path__ + "31af57e0adb64bcb98d40ee86fe3d0f3.png";